import * as actions from './actions'
import * as matchers from './matchers'
export * from './model'

export const translation = { actions, matchers }

export default translation
